import "react/jsx-runtime";
import { typography } from "../../../themes/typography/typography.js";
import "color-alpha";
import "@mui/material";
import "../../../themes/external-theme/external-theme.js";
import "../../../themes/pickers-popper/pickers-popper.js";
import "../../../themes/shadows/shadows.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../constants/breakpoints/breakpoints.js";
import "../../../constants/create-theme/create-theme.js";
import "@mui/material/styles";
import "../../../constants/colors/palette.js";
import "../../../themes/alert/alert.js";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/button/button.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../themes/checkbox/checkbox.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/form-control-label/form-control-label.js";
import "../../../themes/radio/radio.js";
import "../../../themes/switch/switch.js";
const indicatorWrapper = {
  display: "flex",
  gap: "8px",
  alignItems: "center"
};
const dotWrapper = {
  width: "10px",
  height: "10px",
  position: "relative"
};
const smallDotSize = "10px";
const dotIndicator = (color) => ({
  width: smallDotSize,
  height: smallDotSize,
  top: "1.67px",
  left: "1.67px",
  borderRadius: "100px",
  position: "absolute",
  background: color
});
const tooltipContentWrapper = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  color: "grey.800",
  padding: "16px",
  borderRadius: "8px"
};
const tooltipDotWrapper = {
  width: "24px",
  height: "24px",
  position: "relative"
};
const largeDotSize = "20px";
const tooltipIndicator = (color) => ({
  width: largeDotSize,
  height: largeDotSize,
  top: "2px",
  left: "2px",
  borderRadius: "100px",
  position: "absolute",
  backgroundColor: color
});
const tooltipLabel = {
  ...typography["Lato Emphasized 1"]
};
const tooltipReason = {
  ...typography["Lato Body 2"]
};
export {
  dotIndicator,
  dotWrapper,
  indicatorWrapper,
  tooltipContentWrapper,
  tooltipDotWrapper,
  tooltipIndicator,
  tooltipLabel,
  tooltipReason
};
